import { Cloud, K8sProvider } from '@cast/shared-types';
import {
  Cluster,
  ClusterDisplayStatus,
  ClusterRegion,
  ClusterStatus,
} from '@cast/types';

import { ClusterListEntity } from '../../../features/dashboard/types';

export type NotFoundClusterItem = {
  id: string;
  name: string;
  providerNamespaceId?: string;
  isManaged: boolean;
  agentSnapshotReceivedAt?: string;
  providerType?: K8sProvider;
  provider?: K8sProvider;
  displayStatus?: ClusterDisplayStatus;
  status?: ClusterDisplayStatus | ClusterStatus;
  region?: ClusterRegion;
  original?: Cluster;
  clouds?: Cloud[];
};

const isClusterListEntity = (
  cluster: NotFoundClusterItem
): cluster is ClusterListEntity =>
  'original' in cluster && cluster.original !== undefined;

export const toClusterListEntity = (
  cluster: NotFoundClusterItem
): ClusterListEntity => {
  if (isClusterListEntity(cluster)) {
    return cluster;
  }

  const {
    clouds,
    providerType,
    provider,
    displayStatus,
    region,
    ...restCluster
  } = cluster;

  return {
    ...restCluster,
    clouds: clouds ?? [],
    provider: providerType ?? provider,
    status: displayStatus ?? ClusterDisplayStatus.NOT_FOUND,
    region: region ?? { displayName: '', name: '' },
    original: cluster as unknown as Cluster,
  };
};
